
import { SlideDrawer } from "../objects/slide-drawer"

const SEL_BUNDLE_FORM_TOGGLE = '[data-bundle-form-toggle]';
const SEL_BUNDLE_FORM_DRAWER = '[data-bundle-builder]';
const SEL_BUNDLE_RADIOS = '[data-bundle-radio]';

export class BundleBuilderOptionForm extends HTMLElement {
  private bundleCreateBtn: HTMLButtonElement | null = null
  private bundleCreateDrawer: SlideDrawer | null = null
  private bundleRadios: HTMLInputElement[] = [];
  private glassAttribute:string = 'is-glass';

  constructor() {

    super()

    this.queryChildren();
    this.attachEvents();
  }

  queryChildren() {
    this.bundleCreateBtn = this.querySelector(SEL_BUNDLE_FORM_TOGGLE);
    this.bundleCreateDrawer = document.querySelector(SEL_BUNDLE_FORM_DRAWER);
    this.bundleRadios = [...this.querySelectorAll(SEL_BUNDLE_RADIOS) as NodeListOf<HTMLInputElement>]

  }

  handleBundleRadioChange(radio: HTMLInputElement) {
    const event = new CustomEvent('variant_change', { 
      detail: { addGlass: radio.hasAttribute(this.glassAttribute) }, 
      bubbles: true, 
      composed: true 
    });

    this.dispatchEvent(event);
  }

  setActiveOption(addGlass:boolean) {
    this.bundleRadios.forEach(radio => {
      const isGlassOption = radio.hasAttribute(this.glassAttribute);
      radio.checked = isGlassOption === addGlass;
    });
  }

  attachEvents() {
    if(this.bundleCreateBtn) {
      this.bundleCreateBtn.addEventListener("click", () => {
        if (this.bundleCreateDrawer) {
          this.bundleCreateDrawer.visible = true;
          this.bundleCreateDrawer.addDrawerClass = 'o-bundle-builder-slide';
        }
      });
    }

    if (this.bundleRadios) {
      this.bundleRadios.forEach(radio => radio.addEventListener('change', () => this.handleBundleRadioChange(radio)))
    }
  }
}

if(!customElements.get('bundle-builder-option')) {
  customElements.define('bundle-builder-option', BundleBuilderOptionForm);
}